<template src="./AppStartupError.html">
</template>


<script>
import mainHeader from "./startup-error/Header.vue";
import mainFooter from "./startup-error/Footer.vue";

export default {
  props: ["appData"],
  name: "main-app",
  components: {
    mainHeader,
    mainFooter
  },

  data() {
    return {
      errorMessage: this.$props.appData
    };
  }
};
</script>


<style lang="scss">
@import "./assets/scss/main.scss";
</style>
